import { moduleName } from '@/constants/global/module';
import { CustomRouteRecord } from '@/types/router/router';

const meta = {
  moduleName: moduleName.BusinessIntelligence,
  moduleVersion: '1.0.0',
};

const analyticsRoute: Array<CustomRouteRecord> = [
  {
    path: '/analytics/dashboard',
    name: 'analytics-dashboard',
    component: () => import('@/views/modules/analytics/pages/bi-dashboard/BusinessIntelligence.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'bi.dashboard',
      },
    ],
  },
  {
    path: '/analytics/export-preview',
    component: () => import('@/views/modules/analytics/pages/bi-export-preview/ExportPreview.vue'),
    meta: {
      ...meta,
      layout: 'full',
    },
    breadcrumb: [
      {
        text: 'bi.dashboard',
      },
    ],
  },
];

export default analyticsRoute;
